import apiClient from '../api/api';

const getInstitutionCode = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('auth-storage'));
    return authData?.state?.institution?.code || '';
  } catch (e) {
    console.warn('Error reading institution code', e);
    return '';
  }
};

const buildBasePath = (moduleTopicUuid, questionUuid, customInstCode) => {
  const instCode = customInstCode || getInstitutionCode();
  return `/resource/questionbank/${instCode}/${moduleTopicUuid}/${questionUuid}`;
};

const parseMaybeEncodedJson = (raw) => {
  if (!raw) return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw !== 'string') return null;
  if (raw.trim().startsWith('{') || raw.trim().startsWith('[')) {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  const isHex = raw.length % 2 === 0 && /^[0-9a-fA-F]+$/.test(raw);
  if (isHex) {
    try {
      let text = '';
      for (let i = 0; i < raw.length; i += 2) {
        text += String.fromCharCode(parseInt(raw.substr(i, 2), 16));
      }
      return JSON.parse(text);
    } catch {
      return null;
    }
  }

  return null;
};

const fetchQuestionImageUrls = async (moduleTopicUuid, questionUuid, customInstCode) => {
  if (!moduleTopicUuid || !questionUuid) return { imageUrls: [], htmlUrls: [] };

  const basePath = buildBasePath(moduleTopicUuid, questionUuid, customInstCode);
  const metadataUrl = `${basePath}/metadata.json`;

  try {
    const response = await apiClient.get(metadataUrl);
    const metadata = parseMaybeEncodedJson(response.data) ?? response.data;
    let fileNames = [];
    let htmlFiles = [];
    if (Array.isArray(metadata)) {
      fileNames = metadata;
    } else if (Array.isArray(metadata?.files)) {
      fileNames = metadata.files;
    } else if (Array.isArray(metadata?.images)) {
      fileNames = metadata.images;
    } else if (metadata?.fileName) {
      fileNames = [metadata.fileName];
    }
    if (Array.isArray(metadata?.htmlFiles)) {
      htmlFiles = metadata.htmlFiles;
    } else if (metadata?.htmlPath) {
      htmlFiles = [metadata.htmlPath];
    }

    const imagePromises = fileNames.map(async (name) => {
      const url = `${basePath}/${name}`;
      try {
        const resp = await apiClient.get(url, { responseType: 'blob' });
        const blobUrl = URL.createObjectURL(resp.data);
        return { fileName: name, url: blobUrl };
      } catch (err) {
        console.error(`Failed to load image blob for ${name}`, err);
        return null;
      }
    });

    const loadedImages = (await Promise.all(imagePromises)).filter(Boolean)
    const htmlPromises = htmlFiles.map(async (name) => {
      const url = `${basePath}/${name}`;
      try {
        const resp = await apiClient.get(url, { responseType: 'blob' });
        const blobUrl = URL.createObjectURL(resp.data);
        return { fileName: name, url: blobUrl };
      } catch (err) {
        console.error(`Failed to load html blob for ${name}`, err);
        return null;
      }
    });

    const loadedHtmls = (await Promise.all(htmlPromises)).filter(Boolean);
    return { imageUrls: loadedImages, htmlUrls: loadedHtmls };
  } catch (error) {
    console.error('Error fetching question assets metadata', error);
    throw error;
  }
};

export default fetchQuestionImageUrls;
